// extracted by mini-css-extract-plugin
module.exports = {"backgroundColor":"_2sC_LXR4J-vi","content":"_1Yiq-HjOBc6Q"};